import { render, staticRenderFns } from "./BusinessNicheIcon.vue?vue&type=template&id=2a8415fd&scoped=true"
import script from "./BusinessNicheIcon.vue?vue&type=script&lang=js"
export * from "./BusinessNicheIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a8415fd",
  null
  
)

export default component.exports